type tServiceTypeDisplayFriendly = {
    [key: number]: string
}

export const ServiceTypeDisplayFriendly: tServiceTypeDisplayFriendly = {
    5: "Class 5",
}